var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('menu-list',[_c('template',{slot:"1"},[_c('internal-link',{attrs:{"name":"team"}},[_vm._v(_vm._s(_vm.$t('team')))])],1),_vm._v(" "),_c('template',{slot:"2"},[_c('internal-link',{attrs:{"name":"contact"}},[_vm._v(_vm._s(_vm.$t('contact')))])],1),_vm._v(" "),_c('template',{slot:"3"},[_c('internal-link',[_c('switcher-container')],1)],1)],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2c77de4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Navigation/RightMenuContainer.vue
// module id = null
// module chunks = 